import type { SxProps, Theme } from '@mui/material/styles'
import {
  settingsToolbarFormControlSx,
  settingsToolbarOutlinedInputSx,
  settingsToolbarSelectSx,
} from '@/sections/settings/settings-toolbar-styles'

export const referentialFormLabelSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  mb: 0.5,
  fontSize: 12,
  fontWeight: 600,
  color: 'text.primary',
  lineHeight: 1.4,
}

export const referentialSelectFormControlSx: SxProps<Theme> =
  settingsToolbarFormControlSx

export const referentialSelectSx: SxProps<Theme> = {
  ...settingsToolbarSelectSx,
  borderRadius: '8px',
  fontSize: 13,
  bgcolor: 'background.paper',
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '8px',
  },
}

export const referentialOutlinedInputSx: SxProps<Theme> = {
  ...settingsToolbarOutlinedInputSx,
  borderRadius: '8px',
  fontSize: 13,
}
